// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3KfQ5","label":"LabeledBox_label__hP2FC"};